<template lang="pug">
el-dialog(:visible.sync="isShowDialog" width="750px" height="565px" :close-on-click-modal="false"
  @close="closeDialog" title="分享资源单" destroy-on-close)
  .dialog-tips
    img(src="@/assets/tips-icon.png")
    span 资源单复制成功后可以群发给QQ/微信好友
  .tabs
    .tab-item(:class="{'tab-active': tabType === 'text' }" @click="changeTabs('text')") 文字模式
    .tab-item(:class="{'tab-active': tabType === 'img' }" @click="changeTabs('img')") 图片模式
  .quotation-box
    .copyArea
      .quotation-info(:class="{'quotation-info-img': tabType === 'img'}")
        .text-type(v-show="tabType === 'text'")
          .goods-text(v-if="isShowCopyText" v-html="getGoodsText()")
          el-input(v-else type="textarea" v-model="goodsListText")

        img.img-type(:src="quotationImgUrl" v-show="tabType === 'img' && quotationImgUrl")
        .img-type-box(v-show="tabType === 'img' && !quotationImgUrl")
          .header
            .name 现货资源单
            time.time {{Date.now() | parseTime('{M}月{d}日 {h}:{m}')}}报价
          .shop-info
            .info(v-if="shopInfo.id")
              .shop-header
                img.shop-logo-box(:src="FILE_ROOT + '/' + shopInfo.logo")
                .lh15
                  .shop-name {{shopInfo.shopName}}
                  .config-info
                    p(v-for="(item, index) in shopServices" Key="index") {{item}}
              .shop-config
                span.label 主营业务：
                span {{shopInfo.businessScope}}
              .shop-config
                span.label 所在地区：
                span {{shopInfo.province}} {{shopInfo.province === shopInfo.city ? '' : shopInfo.city}}
              .shop-config
                span.label 联系方式：
                span {{$store.state.user.name}} {{ userPhone }}
            .qr-code(v-if="appShareUrl")
              qr-code(:text="appShareUrl" :size="80" error-level="L")
              .tips 扫码下单
          .goods-list(v-for="item, index in goodsList" :key="index")
            .title {{item.partName}}
            el-table.quotation-table(:data="item.shareItemVOS" style="width: 480px" size="mini" border
              :header-cell-style="{'font-size': '12px', background: '#FAFAFA', color: '#999999', 'border-top': '1px solid #f5f5f5', 'border-bottom': '1px solid #f5f5f5' }"
              v-if="item.partId !== 10241202 && item.partId !== 10241246")
              el-table-column(label="品名" align="center" prop="pName" width="60px")
              el-table-column(label="材质" align="center" prop="material" width="50px")
              el-table-column(label="规格" align="center" prop="spec" width="110px")
              el-table-column(label="钢厂" align="center" prop="steelMill" width="50px")
              el-table-column(label="仓库" align="center" prop="nameAbbr" width="60px")
              el-table-column(label="计量方式" align="center" prop="singlyWight" width="80px"
                v-if="item.partId !== 10241202 && item.partId !== 10241246")
              el-table-column(label="价格" align="center" width="69px")
                template(slot-scope="scope")
                  span.price(v-if="scope.row.price") {{(scope.row.price / 100).toFixed(2)}}
            el-table.quotation-table(:data="item.shareItemVOS" style="width: 480px" size="mini" border v-else
              :header-cell-style="{'font-size': '12px', background: '#FAFAFA', color: '#999999', 'border-top': '1px solid #f5f5f5', 'border-bottom': '1px solid #f5f5f5' }")
              el-table-column(label="品名" align="center" prop="pName" width="80px")
              el-table-column(label="材质" align="center" prop="material" width="60px")
              el-table-column(label="规格" align="center" prop="spec" width="110px")
              el-table-column(label="钢厂" align="center" prop="steelMill" width="70px")
              el-table-column(label="仓库" align="center" prop="nameAbbr" width="80px")
              el-table-column(label="价格" align="center" width="79px")
                template(slot-scope="scope")
                  .price(v-if="scope.row.price") {{(scope.row.price / 100).toFixed(2)}}
          .warehouses
            .title 仓库地址
            .warehouse
              .item(v-for="item, index in warehouses" :key="index")
                .name(v-if="item.nameAddr") {{item.nameAddr}}：
                .address(v-if="item.nameAddr") {{item.addrName}}
          .remark(v-show="remark")
            .title 备注
            .remark-info {{remark}}
      .other-info(v-show="tabType === 'img' && checked && isShowCopyText")
        .copy-text.ml-80 {{hintText}}
    el-checkbox.select-info(v-model="checked" v-show="tabType === 'img'") 添加后缀
    .other-info(v-show="tabType === 'img' && (!checked || !isShowCopyText)")
      el-input.ml-80(v-model="hintText")
    .download-btn#confirmDownload(v-show="tabType === 'img'" @click="confirmOperate('Download')") 下载图片
    .text-tips(v-show="tabType === 'text'")
      | 当前{{goodsListText.length || 0}}字，如需复制到微信QQ等发送资源单消息，如显示字数过长请分开发送消息
    el-input.mb10(v-model="remark" v-show="tabType === 'img'" maxlength="100" placeholder="可输入备注内容，备注内容将显示在图片上"
      show-word-limit :rows="3" type="textarea" @input="changeRemark" @blur="updateRemark")

  .dialog-footer(slot="footer")
    el-button#confirmCopy.ml-20(type="primary" @click="confirmOperate('Copy')") 确认复制

  el-dialog.tips-dialog(:visible.sync="isShowTips" width="420px" top="30vh" title="提示"
    :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body)
    .tips-info 资源单图片已经生成，如果复制失败，请手动复制或者下载图片
    .dialog-footer(slot="footer")
      el-button#confirmCopy(type="primary" @click="copyInfo('tips')") 确认
</template>

<script>
import { FILE_ROOT, V2_ROOT, ZM_ROOT } from '@/common/constants/'
import QrCode from 'vue-qrcode-component'
import Clipboard from 'clipboard'
import html2canvas from 'html2canvas'
import { upload } from '@/common/services/upload'

export default {
  name: 'QuotationDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      default: () => []
    },
    warehouses: {
      type: Array,
      default: () => []
    },
    type: {
      type: String,
      default: 'text'
    }
  },
  components: {
    QrCode
  },
  data() {
    return {
      isShowDialog: false,
      goodsList: [],
      goodsListText: '',
      tabType: 'text',
      listCount: 0,
      shopInfo: {},
      FILE_ROOT,
      appShareUrl: '',
      pcShareUrl: '',
      userPhone: '',
      text: '1',
      checked: true,
      quotationImgUrl: '',
      isShowCopyText: false,
      isShowTips: false,
      remark: '',
      hintText: '',
      shopServices: [] // 店铺服务信息
    }
  },
  watch: {
    value(val) {
      this.isShowDialog = val
      this.$emit('input', val)
      if (this.isShowDialog) {
        this.quotationImgUrl = ''
        this.goodsList = this.data
        this.goodsListText = ''
        this.goodsList &&
          this.goodsList.forEach(item => {
            if (item.shareItemVOS) {
              const goods = item.shareItemVOS
              goods &&
                goods.forEach(_item => {
                  this.goodsListText += `\n${_item.pName || ''}   ${_item.spec ||
                    ''}   ${_item.material || ''} ${_item.steelMill || ''}   ${_item.nameAbbr ||
                    ''}   ¥${_item.price ? (_item.price / 100).toFixed(2) : ''}   ${_item.remark ||
                    ''}`
                })
            }
          })
        this.tabType = this.type
        this.listCount = this.goodsList.length || 0
        this.shopInfo = this.$store.state.shop.info || {}
        this.getShopServces()
        this.getShareCode()
      }
    }
  },
  methods: {
    // 修改备注
    async changeRemark() {
      this.quotationImgUrl = ''
    },
    // 修改备注
    async updateRemark() {
      try {
        await this.$post('items.seller.doGetShareCode', {
          querySharesDTO: {
            sharecode: this.shareCode,
            remark: this.remark
          }
        })
      } catch (err) {
        console.log(err)
      }
    },
    //生成商品code
    async getShareCode() {
      const itemIds = []
      this.goodsList &&
        this.goodsList.forEach(item => {
          item.shareItemVOS &&
            item.shareItemVOS.forEach(goods => {
              itemIds.push(goods.id)
            })
        })
      try {
        const result = await this.$post('items.seller.doGetShareCode', {
          querySharesDTO: {
            itemIds,
            shopid: this.shopInfo.id,
            userid: this.$store.state.user.id,
            remark: this.remark
          }
        })
        if (result.success) {
          this.shareCode = (result.data[0] && result.data[0].value) || ''
          this.appShareUrl = `https:${V2_ROOT}/#/quotation?shopId=${this.shopInfo.id}&qtnCode=${this.shareCode}`
          this.pcShareUrl = `${ZM_ROOT}/share/quotation?shopId=${this.shopInfo.id}&qtnCode=${this.shareCode}`
          this.hintText = `今日报价资源单，点击右边链接购买 ：https:${this.pcShareUrl}`
          this.getServiceList()
        }
      } catch (err) {
        console.log(err)
      }
    },
    /** 获取当前店铺客服信息 */
    async getServiceList() {
      try {
        const result = await this.$get('user.getSelfPhone')
        if (result.success) {
          const phone = result.data[0].value || ''
          this.userPhone = phone && phone.replace('+86', '')
          this.goodsListText = `${this.hintText}\n联系人：${this.$store.state.user.name} ${this.userPhone}${this.goodsListText}`
        }
      } catch (err) {
        console.log(err)
      }
    },
    //获取店铺服务信息
    getShopServces() {
      this.shopServices = []
      const shopConfig = this.shopInfo && this.shopInfo.shopConfig
      const ticket = `${shopConfig.invoiceCycle === 1 ? '当月' : '隔月'}${
        shopConfig.invoiceDay
      }号开票`
      this.shopServices.push(ticket)
      shopConfig.invoiceType &&
        shopConfig.invoiceType.forEach(item => {
          if (item.checked) this.shopServices.push(item.pText)
        })
      shopConfig.serviceTag &&
        shopConfig.serviceTag.forEach(item => {
          if (item.checked) this.shopServices.push(item.pText)
        })
      shopConfig.deliveryType &&
        shopConfig.deliveryType.forEach(item => {
          if (item.checked) this.shopServices.push(item.pText)
        })
    },
    // 切换tab
    changeTabs(type) {
      this.tabType = type
    },
    // 确认复制
    confirmOperate(type) {
      if (this.quotationImgUrl || this.tabType === 'text') {
        type === 'Copy' ? this.copyInfo() : this.downloadPic()
      } else if (this.tabType === 'img') {
        const quotationImgDom = document.querySelector('.img-type-box')
        if (quotationImgDom) {
          this.loading = this.$loading({
            lock: true,
            text: '正在生成资源单图片',
            spinner: 'el-icon-loading',
            customClass: 'custom-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
          const width = quotationImgDom.offsetWidth
          const height = quotationImgDom.offsetHeight
          const canvas = document.createElement('canvas')
          const scale = 1.3
          canvas.width = width * scale
          canvas.height = height * scale
          canvas.style.width = width + 'px'
          canvas.style.height = height + 'px'
          const context = canvas.getContext('2d')
          context.scale(scale, scale)
          const opts = {
            width,
            height,
            backgroundColor: null,
            taintTest: true, // 在渲染前测试图片
            timeout: 200,
            logging: false,
            allowTaint: true,
            useCORS: true
          }
          html2canvas(quotationImgDom, opts)
            .then(canvas => {
              canvas.toBlob(async blob => {
                const filename = '资源单.jpg'
                const file = new File([blob], filename, { type: 'image/jpg' })
                this.isShowCopyText = true
                try {
                  const res = await upload(file)
                  if (res.status === 200) {
                    this.isShowTips = type === 'Copy'
                    this.quotationImgUrl = `${FILE_ROOT}${res.data}`
                    setTimeout(() => {
                      this.loading.close()
                      document.getElementById(`confirm${type}`).click()
                    }, 800)
                  }
                } catch (err) {
                  this.loading.close()
                  this.$message.warning('生成资源单图片失败!')
                }
              })
            })
            .catch(err => {
              this.$message.warning('生成资源单图片失败!')
            })
        } else {
          this.$message.warning('生成资源单图片失败')
        }
      }
    },
    // 确认下载
    downloadPic() {
      if (this.quotationImgUrl) {
        const link = document.createElement('a')
        const newTab = window.open('about:blank')
        newTab.location.href = this.quotationImgUrl
        link.setAttribute('download', '资源单.png')
        link.style.display = 'none'
        document.body.appendChild(link)
        link.click()
      }
    },
    // 关闭弹窗
    closeDialog() {
      this.isShowDialog = false
      this.$emit('input', false)
    },
    // 确认复制
    copyInfo(type) {
      this.isShowCopyText = true
      const copyArea = document.querySelector('.copyArea')
      const clipboard = new Clipboard('#confirmCopy', {
        target: function() {
          return copyArea
        }
      })
      clipboard.on('success', evt => {
        this.$message.closeAll()
        if (!this.isShowTips && type !== 'tips') {
          this.$message.success('复制成功')
        }
        if (type === 'tips') this.isShowTips = false
        clipboard.destroy()
      })
      clipboard.on('error', evt => {
        this.$message.closeAll()
        if (!this.isShowTips && type !== 'tips') {
          this.$message.error('复制失败，请稍后重试')
        }
        if (type === 'tips') this.isShowTips = false
        clipboard.destroy()
      })
      setTimeout(() => {
        this.isShowCopyText = false
      }, 2000)
    },
    //打开pc分享链接
    openLink() {
      window.open(this.pcShareUrl)
    },
    getGoodsText() {
      const text = this.goodsListText
      const newText = text.replace(/\n/g, '</br>')
      return newText
    }
  }
}
</script>

<style lang="stylus" scoped>
*
  box-sizing border-box
.dialog-tips
  font-size 12px
  margin-bottom 15px
  font-weight 700
  display flex
  align-items center
  margin-left -4px
  img
    margin 6px
    width 12px
    height 12px

.tabs
  display flex
  align-items center
  .tab-item
    height 36px
    line-height 36px
    text-align center
    width 98px
    font-size 14px
    color #333333
    cursor pointer
  .tab-active
    color #cd974c
    border-top 1px solid #cd974c
    border-left 1px solid #f2f2f2
    border-right 1px solid #f2f2f2
    background-color #FCFCFC
    height 38px
    margin-bottom -2px
    z-index 999

.quotation-box
  position relative
.quotation-info
  position relative
  padding 20px
  border 1px solid #f2f2f2
  color #ffffff
  background-color #FCFCFC
  height 310px
  overflow hidden
  overflow-y scroll
  -webkit-overflow-scrolling：touch
  /deep/.el-textarea__inner
    height 310px
    border 0
    font-size 14px
    line-height 28px
  .goods-text
    height 350px
    border 0
    font-size 14px
    line-height 28px
    padding 5px 15px
    color #666
  .text-type
    color #333333
  .img-type-box
    width 510px
    background-color #ffffff
    margin 0 auto
    padding 25px 12px
  .header
    display flex
    justify-content space-between
    align-items flex-end
    text-align center
    color #333333
    margin-bottom 14px
    font-size 12px
    .name
      color #000000
      font-size 16px
      font-weight 500
    time
      color #666666
  .config-info
    display flex
    flex-wrap wrap
    color #cd974c
    p
      margin-right 5px
      line-height 1.2
  .shop-info
    padding 15px
    display flex
    color #333333
    font-size 12px
    box-shadow 0px 8px 64px -8px rgba(0,0,0,0.06)
    border 1px solid #F0F0F0
    border-radius 4px
    .label
      color #666666
    .shop-name
      font-size 16px
      font-weight 500
      margin-bottom 5px
    .shop-header
      display flex
      align-items center
      margin-bottom 18px
    .info
      flex 1
    .shop-config
      margin-top 12px
    .tips
      font-size 12px
      color #333333
      text-align center
      margin-top 10px
    .qr-code
      width 90px
      height 90px
      border 1px solid #e9e9e9
      /deep/img
        margin 4px
    .lh15
      line-height 1.5
    .shop-logo-box
      width 40px
      height 40px
      margin-right 10px
.other-info
  display flex
  align-items center
  margin-top 20px
  margin-bottom 16px
  overflow hidden
  .copy-text
    border: 1px solid #dcdcdc;
    height 32px
    line-height 32px
    padding 0 15px
    white-space pre-wrap
    flex 1
  .ml-80
    margin-left 80px
    /deep/.el-input__inner
      height 32px
      line-height 32px
      font-size 13px
.quotation-box
  .select-info
    min-width 80px
    position absolute
    bottom 98px
    /deep/.el-checkbox__label
      color #333333 !important
      font-size 13px
.img-type
  display block
  margin 0 auto
  width 80%
  height auto
.mb10
  display block
  margin-bottom 10px
.ml-20
  margin-left 20px
.el-table th>.cell
  padding-left 0
  padding-right 0
.goods-list
  /deep/.el-table .cell
    line-height 1.2
    color #333
    padding 0 4px
  /deep/.el-table__header
    .cell
      color #999999
      font-weight 400
  /deep/.el-table--border, .el-table--group
    border 1px solid #f5f5f5
  /deep/.el-table--border td, .el-table--border th, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed
    border-right 1px solid #f5f5f5
  /deep/.el-table td, .el-table th.is-leaf
    border-bottom 1px solid #f5f5f5
  /deep/.el-table--border td, .el-table--border th, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed
    border-bottom 1px solid #f5f5f5
  /deep/.el-table--border::after, .el-table--group::after
    width 0
.title
  font-size 13px
  font-weight 600
  margin 20px 0 8px 0
  color #333333
.price
  color #cd974c
  font-weight 500
  text-align right
  display block
.item
  display flex
  padding 5px 0
.warehouse, .remark-info
  color #333333
  font-size 12px
  padding 7px 15px
  line-height 1.5
  background-color #FAFAFA
.remark-info
  padding 13px 15px
.download-btn
  position absolute
  right 20px
  bottom 160px
  width 72px
  height 28px
  display flex
  justify-content center
  align-items center
  background #666666
  border-radius 28px
  color #FFFFFF
  text-align center
  font-size 12px
  cursor pointer
  &:hover
    opacity 0.8
.quotation-info-img
  height 186px
.text-tips
  font-size 12px
  color #999999
  margin-top 15px
.tips-dialog
  /deep/.el-dialog__header
    padding 28px 30px 18px
  /deep/.el-dialog--center .el-dialog__body
    padding 25px 35px 15px
    .el-button--primary
      font-weight 400
  .tips-info
    line-height 1.5
.el-icon-info
  color #999999
  margin-right 8px
</style>

<style lang="stylus">
.custom-loading
  p, i
    color #ffffff !important
/deep/.quotation-table td, .quotation-table th.is-leaf
  border-bottom 1px solid red
</style>
